var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-show-files" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "documents-show-files-modal",
            size: "custom-size",
            "no-enforce-focus": "",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          on: {
            close: function ($event) {
              _vm.localActive = false
            },
          },
          model: {
            value: _vm.localActive,
            callback: function ($$v) {
              _vm.localActive = $$v
            },
            expression: "localActive",
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "m-show-files-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: {
                click: function ($event) {
                  _vm.localActive = false
                },
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _c("div", { staticClass: "m-show-files-title" }, [
            _vm._v("Просмотр файлов"),
          ]),
          _c(
            "div",
            { staticClass: "m-show-files-content" },
            [
              _c("div", {
                staticClass: "m-show-files-content-shadow-top",
                attrs: { id: "m-show-files-content-shadow-top" },
              }),
              _vm.appendLocalFiles.length > 0
                ? _c("viewer", { attrs: { images: _vm.appendLocalImages } }, [
                    _c(
                      "div",
                      {
                        staticClass: "m-show-files-content-files",
                        attrs: { id: "m-show-files-content-files" },
                        on: { scroll: _vm.setShadowFilesList },
                      },
                      _vm._l(_vm.appendLocalFiles, function (file, index) {
                        return _c(
                          "div",
                          {
                            key: `file-${index}`,
                            staticClass: "m-show-files-content-files-item",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-show-files-content-files-item-container",
                              },
                              [
                                file.format === "jpeg" ||
                                file.format === "png" ||
                                file.format === "gif" ||
                                file.format === "jpg"
                                  ? _c("img", {
                                      staticClass:
                                        "m-show-files-content-files-item-container-photo",
                                      attrs: { src: file.src },
                                    })
                                  : file.format === "pdf"
                                  ? _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "m-show-files-content-files-item-container-icon",
                                        attrs: {
                                          width: "33",
                                          height: "33",
                                          viewBox: "0 0 33 33",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadFile(file)
                                          },
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M1.5 31.5V1.5H31.5V31.5H1.5Z",
                                            stroke: "#E30000",
                                            "stroke-width": "3",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d: "M18.4486 14.7397C17.205 15.7354 17.1654 15.7596 16.431 16.3868C15.6967 17.014 15.4226 17.1035 14.1731 18.0923M18.4486 14.7397C22.6951 13.107 23.8297 9.49956 20.8864 8.43992C17.943 7.38027 16.3731 10.9298 18.4486 14.7397ZM18.4486 14.7397C18.7117 16.2779 18.7225 16.2654 18.8943 17.2736C19.0695 18.3012 19.0607 18.4132 19.3329 19.95M14.1731 18.0923C15.6889 18.6333 16.7871 19.0334 16.7871 19.0334C16.7871 19.0334 17.8203 19.4006 19.3329 19.95M14.1731 18.0923C10.584 15.3615 6.77769 16.2174 7.29796 19.2059C7.81822 22.1944 11.7902 21.731 14.1731 18.0923ZM19.3329 19.95C23.8993 20.1552 26.1933 23.2073 23.7703 25.1362C21.3472 27.065 18.6614 24.2047 19.3329 19.95Z",
                                            stroke: "#E30000",
                                            "stroke-width": "2",
                                          },
                                        }),
                                      ]
                                    )
                                  : _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "m-show-files-content-files-item-container-icon",
                                        attrs: {
                                          width: "33",
                                          height: "33",
                                          viewBox: "0 0 33 33",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadFile(file)
                                          },
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M26.4277 8.36804L23.6437 25H18.5317L16.4677 12.304L14.2837 25H9.29166L6.55566 8.36804H10.4917L12.1477 22.024L14.4517 8.36804H18.5797L20.7397 22.024L22.6837 8.36804H26.4277Z",
                                            fill: "#2B579A",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d: "M1.5 31.5V1.5H31.5V31.5H1.5Z",
                                            stroke: "#2B579A",
                                            "stroke-width": "3",
                                          },
                                        }),
                                      ]
                                    ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-show-files-content-files-item-name",
                              },
                              [_vm._v(_vm._s(file.name))]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-show-files-content-files-item-overlay",
                              },
                              [
                                _vm.documentFormatOverlayIcon(file.format)
                                  ? _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "26",
                                          height: "26",
                                          viewBox: "0 0 26 26",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M7.70711 12.2929C7.31658 11.9024 6.68342 11.9024 6.29289 12.2929C5.90237 12.6834 5.90237 13.3166 6.29289 13.7071L7.70711 12.2929ZM13 19L12.2929 19.7071C12.6834 20.0976 13.3166 20.0976 13.7071 19.7071L13 19ZM19.7071 13.7071C20.0976 13.3166 20.0976 12.6834 19.7071 12.2929C19.3166 11.9024 18.6834 11.9024 18.2929 12.2929L19.7071 13.7071ZM14 1C14 0.447715 13.5523 0 13 0C12.4477 0 12 0.447715 12 1H14ZM26 19C26 18.4477 25.5523 18 25 18C24.4477 18 24 18.4477 24 19H26ZM2 19C2 18.4477 1.55228 18 1 18C0.447715 18 0 18.4477 0 19H2ZM6.29289 13.7071L12.2929 19.7071L13.7071 18.2929L7.70711 12.2929L6.29289 13.7071ZM13.7071 19.7071L19.7071 13.7071L18.2929 12.2929L12.2929 18.2929L13.7071 19.7071ZM14 19V1H12V19H14ZM24 19V23H26V19H24ZM23 24H3V26H23V24ZM2 23V19H0V23H2ZM3 24C2.44772 24 2 23.5523 2 23H0C0 24.6569 1.34315 26 3 26V24ZM24 23C24 23.5523 23.5523 24 23 24V26C24.6569 26 26 24.6569 26 23H24Z",
                                            fill: "white",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.imageFormatOverlayIcon(file.format)
                                  ? _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "36",
                                          height: "22",
                                          viewBox: "0 0 36 22",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M34 11C34 11 26.8366 21 18 21C9.16344 21 2 11 2 11C2 11 9.16344 1 18 1C26.8366 1 34 11 34 11Z",
                                            stroke: "white",
                                            "stroke-width": "2",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d: "M24 9C24 12.3137 21.3137 15 18 15C14.6863 15 12 12.3137 12 9C12 5.68629 14.6863 3 18 3C21.3137 3 24 5.68629 24 9Z",
                                            stroke: "white",
                                            "stroke-width": "2",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _c("div", {
                staticClass: "m-show-files-content-shadow-bottom",
                attrs: { id: "m-show-files-content-shadow-bottom" },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }